const hasOwnProperty = Object.prototype.hasOwnProperty

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x: unknown, y: unknown): boolean {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y
    /* eslint-disable-next-line no-else-return */
  } else {
    // Step 6.a: NaN == NaN

    /* eslint-disable-next-line no-self-compare */
    return x !== x && y !== y
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
export function shallowEqual(objA: unknown, objB: unknown): boolean {
  if (is(objA, objB)) {
    return true
  }

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false
  }

  const keysA = Object.keys(objA)
  const keysB = Object.keys(objB)

  return (
    // Confirm that they have the same number of properties.
    keysA.length === keysB.length &&
    // Confirm that each property is the same.
    keysA.every(key => {
      return (
        hasOwnProperty.call(objB, key) &&
        is((objA as any)[key], (objB as any)[key])
      )
    })
  )
}
